import { Dialog } from 'quasar'
import PickupConfirmDialog from '@/components/common/PickupConfirmDialog.vue'

/**
 * 打开「确认自提」弹窗（2026-09-24）
 *
 * 三处调用点（PC 管理端订单页 / 业务员操作组件 / 订单页管理员分支）原先各自 window.prompt，
 * 视觉与两端表现不一致、也没法把自提码做出层级；这里收口成同一个入口 + 同一个组件。
 *
 * @param {Vue} vm 调用方组件实例（Dialog.create 需要 parent 以继承主题/上下文）
 * @param {Object} order 订单 DTO，需带 id 与 pickup_code（PC 端由 adminQueryService 补字段）
 * @param {Function} [onConfirmed] 确认成功后的回调（调用方据此刷新列表/详情；不传则只关窗）
 * @returns Quasar Dialog 实例（可继续 .onCancel 等）
 */
export function openPickupConfirm (vm, order, onConfirmed) {
  const pickupCode = order && order.pickup_code ? String(order.pickup_code) : ''
  const dialog = Dialog.create({
    component: PickupConfirmDialog,
    parent: vm,
    // persistent：保持弹窗直到店员明确选择取消/确认——避免误点遮罩消失在核对中途，
    // 也保证请求进行中不会被点掉（失败必须留在弹窗内，见组件说明）
    persistent: true,
    orderId: (order && order.id) || '',
    pickupCode
  })
  if (typeof onConfirmed === 'function') {
    dialog.onOk((payload) => onConfirmed(payload))
  }
  return dialog
}
